import { render, staticRenderFns } from "./InvoiceSidebarAddPayment.vue?vue&type=template&id=048ed005&"
import script from "./InvoiceSidebarAddPayment.vue?vue&type=script&lang=js&"
export * from "./InvoiceSidebarAddPayment.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceSidebarAddPayment.vue?vue&type=style&index=0&id=048ed005&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports